<template>
    <div>
        <td-tree
            :lazyloading="lazyloading"
            :typeContent="typeContent"
            :expandOnClick="expandOnClick"
            :calInternal="calInternal"
            :height="height"
            :checkNodes="checkNodes"
            :draggable="draggable"
            :showBox="showBox"
            :picturePath="treePicture"
            :isClick="isClick"
            :isDbClick="isDbClick"
            :imgloading="imgloading"
            :dragLevel="dragLevel"
            :inputName="inputName"
            :isRightClick="isRightClick"
            :isSingleCheck="isSingleCheck"
            :isPaging="isPaging"
            @onClick="onClick"
            @onRightClick="onRightClick"
            @onDbClick="onDbClickTree"
            :checkStrictly="checkStrictly"
            @checkChange="checkChange"
            ref="TdTree"
            @queryData="queryData"
            :inputShow="inputShow"
            :invertBoxShow="invertBoxShow"
            :defaultProps="defaultProps"
            :nodekey="nodekey"
        >
        </td-tree>
    </div>
</template>
<script>
export default {
    props: {
        treeList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        draggable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        imgloading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        defaultProps: {
            type: Object,
            default: function() {
                return {
                    children: 'children',
                    label: 'caption',
                    id: 'id',
                    imgName: 'sIcon'
                };
            }
        },
        pramars: Object,
        height: {
            type: Number,
            default: function() {
                return window.innerHeight - 145;
            }
        },
        nodekey: {
            type: String,
            default: 'id'
        },
        inputName: {
            type: String,
            default: function() {
                return '';
            }
        },
        showBox: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        picturePath: {
            type: Array,
            default: function() {
                return [];
            }
        },
        typeContent: {
            type: Array,
            default: function() {
                return [];
            }
        },
        calInternal: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        checkNodes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        dragLevel: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isRightClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 树形是否分页
        isPaging: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 点击树形节点是否会展开或者收缩节点
        expandOnClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isSingleCheck: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 根据编号查询树形
        sCodes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 展示根节点ID
        parentOrgIds: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 树形节点类型
        orgTypeIds: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 树形节点Id
        orgIds: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 搜索框是否显示
        inputShow: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 反选框是否显示
        invertBoxShow: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否遵循父节点选中后子节点也相继选中
        checkStrictly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 指定获取设备树Url
        devUrl: {
            type: String,
            default: function() {
                return '';
            }
        },
        // 设备类型
        deviceTypeList: {
            type: Array,
            default: function() {
                return null;
            }
        },
        // 树形搜索框宽度
        inputWidth: {
            type: Number,
            default: function() {
                return 200;
            }
        }
    },
    data() {
        return {
            filterText: '',
            pageSize: 50,
            currentPage: 1,
            defaultKey: [],
            tmpramars: this.pramars,
            lazyLoading: this.lazyloading,
            treedatarideo: [],
            treedataList: [],
            clickData: [],
            allCheckedList: [],
            expandNodeMap: '',
            isUpload: '',
            ischildNode: false,
            isIniTree: false,
            isExpand: false,
            isLoadData: false,
            treeData: '',
            treeNode: '',
            treePicture: {},
            rootNodeList: []
        };
    },
    created() {},
    mounted() {
        this.initTreeIcon();
        this.$log.info(window.innerHeight - 100);
    },
    methods: {
        // 处理复选框勾选
        defaultSelect(checkList) {
            this.checkList = checkList;
        },
        // 树形数据
        queryData(item) {
            if (item !== null && item.caption !== '' && item.caption !== undefined) {
                this.querySearchData(item);
            } else {
                this.queryTreeData(item);
            }
        },
        // 获取组织树形
        queryTreeData: function(item) {
            if (item.parentId === '') {
                item.parentId = this.$common.initOrgDevTreeParam.ROOT_PARENT_ID;
            }
            if (item !== null && item.currentPage !== '' && item.currentPage !== undefined) {
                item.currentPage = 1;
                item.pageSize = 50;
            }
            let queryParam = {
                includeSelf: item.includeSelf,
                needDetail: false,
                needPage: this.isPaging,
                parentId: item.parentId,
                scodes: item.sCodes,
                deviceTypeList: this.deviceTypeList,
                orgTypeIds: this.orgTypeIds
            };
            if (this.isPaging) {
                queryParam.pageNum = item.currentPage;
                queryParam.pageSize = item.pageSize;
            }
            window.pgApi.queryDeviceOrgTree(JSON.stringify(queryParam), this.devUrl === '' ? null : this.devUrl, response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$nextTick(function() {
                            if (item.parentId === '') {
                                // 初始化树形先加载图片
                                this.initTreeIcon(response.data.content);
                            } else {
                                // 树形赋值
                                this.$refs.TdTree.initData(response.data.content, this.checkList);
                            }
                        });
                        if (this.rootNodeList.length === 0) {
                            this.rootNodeList = response.data.content;
                        }
                        if ((response.data.content === null || response.data.content === undefined || !Array.isArray(response.data.content)) && item.parentId === '') {
                            this.initTreeIcon(this.$common.rootNode);
                            this.rootNodeList = this.$common.rootNode;
                            this.onDbClickTree(this.$common.rootNode[0]);
                        }
                        if (!this.hasInitTree) {
                            this.hasInitTree = true;
                            if (response.data.content !== null && response.data.content.length !== 0) {
                                this.onDbClickTree(response.data.content[0]);
                            }
                        }
                    } else {
                        this.initTreeIcon(this.$common.rootNode);
                        this.onDbClickTree(this.$common.rootNode[0]);
                        this.$log.error('/device/queryDeviceOrgTree', response.data.statusMessage);
                    }
                } else {
                    this.initTreeIcon(this.$common.rootNode);
                    this.onDbClickTree(this.$common.rootNode[0]);
                    this.$message.error(this.$t('common.OPERATION_FAIL'));
                    this.$log.error('/device/queryDeviceOrgTree', response);
                }
            });
        },
        getParam: function(item) {
            // 处理根节点
            let parentIdList = [];
            for (let i = 0; i < this.rootNodeList.length; i++) {
                parentIdList.push(this.rootNodeList[i].id);
            }
            let queryVo = {
                includeSelf: true,
                unassorted: true,
                recursiveQuery: true,
                needDetail: false,
                needPage: true,
                parentOrgIds: parentIdList,
                pageNum: 1,
                pageSize: 50,
                deviceTypeList: this.deviceTypeList,
                sName: ''
            };
            if (item != null) {
                queryVo.pageNum = item.currentPage;
                queryVo.pageSize = item.pageSize;
                queryVo.sName = item.caption;
                queryVo.orgTypeIds = this.orgTypeIds;
            }
            if (item.currentPage === []) {
                queryVo.pageNum = 1;
            }
            return queryVo;
        },
        querySearchData: function(param) {
            let queryVo = this.getParam(param);
            let json = JSON.stringify(queryVo);
            // TODO 调用搜索接口，处理搜索树形
            window.pgApi.queryDeviceOrgTreeByName(json, this.devUrl === '' ? null : this.devUrl, response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$refs.TdTree.initData(response.data.content, [], 'searchDate');
                    }
                } else {
                    this.$message.error(this.$t('common.OPERATION_FAIL'));
                    this.$log.error('/device/queryDeviceOrgTreeByName', response);
                }
            });
        },
        initTreeIcon(treeData) {
            window.pgApi.listAllIcon('{}', response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        let types = response.data.content;
                        types.push('devMiddleware');
                        types.push('devVideoHost');
                        types.push('devVideoChannel');
                        types.push('devAdapter');
                        types.push('devFileAdapter');
                        types.push('devFileStorage');
                        for (let i = 0; i < types.length; i++) {
                            const icon = types[i];
                            this.treePicture[icon] = icon + '.png';
                        }
                        if (treeData !== undefined && treeData !== null && treeData.length > 0) {
                            this.$refs.TdTree.initData(treeData, this.checkList);
                        }
                    }
                } else {
                    if (treeData !== undefined && treeData !== null && treeData.length > 0) {
                        this.$refs.TdTree.initData(treeData, this.checkList);
                    }
                }
            });
        },
        // 树形节点右击事件 预留
        onRightClick(event, data) {
            this.$refs.TdTree.onRightClick(event, data);
        },
        getCheckedNodes() {
            if (this.showBox) {
                let checkedNodes = this.$refs.TdTree.getCheckedNodes();
                return checkedNodes;
            }
            return null;
        },
        // 获取当前树形全选中节点id
        getCheckedKeys() {
            return this.$refs.TdTree.getCheckedKeys();
        },
        // 获取当前树形半选中树形节点对象数组
        getHalfCheckedNodes() {
            return this.$refs.TdTree.getHalfCheckedNodes();
        },
        // 通过传入数组设置目前勾选的节点
        setSelectKeys(CheckedList) {
            this.$refs.TdTree.setSelectKeys(CheckedList);
        },
        // 树形节点单击事件
        onClick(data) {
            this.clickData = data;
            if (this.isClick) {
                this.$emit('onClick', data);
            }
        },
        // 树形节点双击事件
        onDbClickTree(data) {
            if (this.isDbClick) {
                this.$emit('onDbClickTree', data);
            }
        },
        // 树形节点添加、修改、删除
        editTreeNode(dataId, operation, value) {
            this.$refs.TdTree.editTreeNode(dataId, operation, value);
        },
        // 单选框，复选框选中状态修改触发
        checkChange(data, isCheck) {
            this.$emit('checkChange', data, isCheck);
        }
    }
};
</script>
<style>
.conshow .el-tree-node__label {
    padding: 0px 0px 0px 25px;
    color: #000;
    margin-left: 0.1em;
    font-size: 14px;
}
.test-1::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}
.test-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #909399;
}
.test-1::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ffffff;
}
.conshow .el-tree > .el-tree-node {
    min-width: 100%;
    display: inline-block;
}
</style>
